import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.NumericColumn("Año", "año"),
    ColumnsFactory.TextColumn("Periodo", "nomPeriodo"),
    ColumnsFactory.TextColumn("Tipo Contenido", "tipoContenido"),
    ColumnsFactory.TextColumn("Nivel Organizativo", "nivelOrganizativo"),
    ColumnsFactory.TextColumn("Centro", "centro"),
    ColumnsFactory.DateTimeColumn("Fecha", "fecha"),
    ColumnsFactory.TextColumn("Usuario", "nomUsuario"),
	  ColumnsFactory.TextColumn("Acción", "descripcionAccion")
  ];
};